import React from 'react';
import { HeadBanner } from '@castlery/modules-others-components';

const BlogBanner = () => {
  return (
    <HeadBanner
      header="Blog"
      description="Discover the latest interior design trends and furniture tips on our blog."
      image={{
        desktop_url: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1758871063/Blog_Desktop_los9nj.png',
        mobile_url: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1758871117/Blog_Mobile_ogrj3q.png',
        tablet_url: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1758871117/Blog_Mobile_ogrj3q.png',
        alt: 'Blog Banner',
      }}
    />
  );
};

export default BlogBanner;
